import { mediaItems } from '@/mocks/home';

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-medium text-accent-600 mb-2">精彩片花</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精彩片花与特辑</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto">幕后花絮、主创访谈、预告解析，更深度的影视内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="400"
                  height="250"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 backdrop-blur-sm rounded text-xs text-white font-medium">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-accent-500/90 rounded-full text-xs text-background-50 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors duration-300">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}